import {
  Box,
  CircularProgress,
  List,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import { ContactDto } from "libs/cellera-sdk";
import { useCelleraTheme } from "theme/useCelleraTheme";

import ContactItem from "./ContactItem";

type ContactListProps = {
  contacts: ContactDto[];
  selectedContact?: ContactDto;
  onSelect: (contact: ContactDto) => void;
  isLoadingMore?: boolean;
  isLoading?: boolean;
  search?: string;
  onSearch: (value: string) => void;
  onOpenRemoveContactModal: (contactId: string) => void;
};

const ContactList: React.FC<ContactListProps> = ({
  contacts,
  selectedContact,
  onSelect,
  isLoading,
  isLoadingMore = false,
  search,
  onSearch,
  onOpenRemoveContactModal,
}: ContactListProps) => {
  const { colors } = useCelleraTheme();

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        paddingRight: "8px",
        backgroundColor: colors.background.paper,
        position: "relative",
      }}
    >
      <Box
        pb={1}
        sx={{
          position: "sticky",
          top: 1,
          zIndex: 1000,
          backgroundColor: colors.background.paper,
        }}
      >
        <TextField
          fullWidth
          placeholder="Search contacts"
          variant="outlined"
          size="medium"
          value={search}
          onChange={(e) => onSearch(e.target.value)}
        />
      </Box>
      <List sx={{ padding: 0 }}>
        {(!contacts || !contacts?.length) && !isLoading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "200px",
              padding: 2,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: colors.text.secondary,
              }}
            >
              No patients assigned yet.
            </Typography>
          </Box>
        )}
        {contacts?.map((contact) => (
          <ContactItem
            key={contact.id}
            contact={contact}
            isSelected={selectedContact?.id === contact.id}
            onSelect={onSelect}
            onDelete={onOpenRemoveContactModal}
          />
        ))}
        {isLoading &&
          Array.from({ length: 5 }).map((_, index) => (
            <Skeleton
              key={index}
              variant="rounded"
              width="100%"
              height={72}
              sx={{ marginBottom: 0.5 }}
              animation="wave"
            />
          ))}
        {/* Loading indicator when fetching more contacts */}
        {isLoadingMore && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: 2,
            }}
          >
            <CircularProgress size={16} />
          </Box>
        )}
      </List>
    </Box>
  );
};

export default ContactList;
